import { articles } from "../../../mocks/gossip";

export default function Relations() {
  return (
    <section id="relations" className="mx-auto w-full max-w-6xl px-4 py-16 md:px-6 md:py-20">
      <div className="mx-auto max-w-2xl text-center">
        <p className="inline-flex items-center gap-2 text-sm font-semibold tracking-wide text-[#b4372a]">
          <span className="h-px w-6 bg-[#b4372a]"></span>关系解析<span className="h-px w-6 bg-[#b4372a]"></span>
        </p>
        <h2 className="mt-3 font-serif-sc text-3xl font-black text-[#2a2320] md:text-4xl">
          看线不如看理：把复杂关系讲透
        </h2>
        <p className="mt-4 leading-relaxed text-[#5a5049]">
          连线只是骨架，真正值得琢磨的是每条连线背后的成因。以下三篇深度内容，帮助你在吃瓜门中保持清醒。
        </p>
      </div>

      <div className="mt-10 grid gap-6 md:grid-cols-3">
        {articles.map((a) => (
          <article key={a.id} className="group flex flex-col overflow-hidden rounded-lg border border-[#eadccb] bg-white">
            <div className="relative h-44 w-full overflow-hidden">
              <img
                src={a.img}
                alt={a.title}
                className="h-full w-full object-cover transition duration-500 group-hover:scale-105"
              />
              <span className="absolute left-3 top-3 rounded-full bg-[#2a2320]/80 px-3 py-1 text-xs text-[#f7e4d6]">
                {a.category}
              </span>
            </div>
            <div className="flex flex-1 flex-col p-5">
              <h3 className="font-serif-sc text-lg font-bold leading-snug text-[#2a2320]">{a.title}</h3>
              <p className="mt-2 flex-1 text-sm leading-relaxed text-[#7a6f66]">{a.excerpt}</p>
              <a
                href="#graph"
                className="mt-4 inline-flex items-center gap-1 text-sm font-semibold whitespace-nowrap text-[#b4372a] transition hover:text-[#98301f]"
              >
                展开完整关系 <i className="ri-arrow-right-line" aria-hidden="true"></i>
              </a>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}